import { doGETRequest, doPOSTRequest, doDELETERequest } from "./Api";

class UserProductListApi {

  public static async getItems() {
    return await doGETRequest("/user-product-lists/items");
  }

  public static async addItem(productId: number) {
    return await doPOSTRequest("/user-product-lists/items", { productId });
  }

  public static async removeItem(itemId: number) {
    return await doDELETERequest(`/user-product-lists/items/${itemId}`, {});
  }

}

export default UserProductListApi;